import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  inject,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { EventType, Router, RouterModule } from '@angular/router';

import { BreadcrumbService } from './core/services/breadcrumb/breadcrumb.service';
import { ShortcutService } from './core/services/shortcuts/shortcut.service';
import { SplashScreenService } from './core/services/splash/splash';
import { ThemeSwitcherService } from './core/themes/theme-switcher.service';
import { environment } from './environments/environment';
import { ProductTourComponent } from './shared/components/product-tour/product-tour.component';

import { KeyboardNavigationService } from './core/services/keyboard/keyboard-navigation.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule, ProductTourComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App implements OnInit {
  title = 'new-customs-web-app';
  envName = environment.envName;
  private appInitialized = false;

  theme = inject(ThemeSwitcherService);
  router = inject(Router);
  splashScreenService = inject(SplashScreenService);
  shortcutService = inject(ShortcutService);
  breadcrumbService = inject(BreadcrumbService);
  keyboardNavService = inject(KeyboardNavigationService);

  ngOnInit() {
    this.theme.init();
    this.shortcutService.init();
    this.setViewportHeight();
    this.router.events.subscribe((evt) => {
      if (evt.type === EventType.NavigationEnd) {
        this.setViewportHeight();
        setTimeout(() => {
          if (!this.appInitialized) {
            this.appInitialized = true;
            this.showApp();
          }
        }, 0);
      }
    });
  }

  private showApp(): void {
    this.splashScreenService.hide();
  }

  @HostListener('window:resize')
  onResize() {
    this.setViewportHeight();
  }

  private setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    document.documentElement.style.setProperty(
      '--env-name',
      `'${environment.envName}'`
    );
  }
}
